<div class="main-container">
	<div class="__form-container" *ngIf="token; else noTokenTemplate">
		<img class="__logo" src="assets/images/logo.jpg" alt="Logo" />
		<p class="text-muted-dark" *ngIf="!passwordMismatchError">
			Por favor, ingrese su nueva contraseña y confírmela para continuar..
		</p>
		<p class="text-danger" *ngIf="passwordMismatchError">
			<strong>Las contraseñas no coinciden.</strong> Verifique la información e
			intente nuevamente.
		</p>
		<form class="__form" [formGroup]="form" (ngSubmit)="onSubmit()">
			<div class="__field-wrapper">
				<mat-form-field class="__field" appearance="standard">
					<mat-label>Nueva Contraseña</mat-label>
					<div class="__input-wrapper">
						<input
							formControlName="password"
							matInput
							[type]="showPassword ? 'text' : 'password'"
							placeholder="Ingrese su contraseña"
						/>
						<div class="__icons" (click)="togglePassword($event)">
							<mat-icon
								class="__eye text-muted"
								[ngClass]="{ '--show': showPassword }"
								>visibility</mat-icon
							>
							<mat-icon
								class="__eye text-muted"
								[ngClass]="{ '--show': !showPassword }"
							>
								visibility_off
							</mat-icon>
						</div>
					</div>
					<mat-error
						*ngIf="passwordField.touched && passwordField.hasError('required')"
					>
						La contraseña es requerida
					</mat-error>
				</mat-form-field>
			</div>
			<div class="__field-wrapper __validation-rules-container">
				<label class="__validation-rules mb2">Requisitos de seguridad</label>
				<div class="__radio-group">
					<mat-radio-group aria-label="Regla de longitud mínima">
						<mat-radio-button
							[checked]="!passwordField.hasError('minLength')"
							[disabled]="true"
							value="minLength"
						>
							Mínimo 8 caracteres
						</mat-radio-button>
					</mat-radio-group>
					<mat-radio-group aria-label="Regla de número obligatorio">
						<mat-radio-button
							[checked]="!passwordField.hasError('noNumber')"
							[disabled]="true"
							value="noNumber"
						>
							Incluir un número (0-9)
						</mat-radio-button>
					</mat-radio-group>
					<mat-radio-group aria-label="Regla de mayúscula obligatoria">
						<mat-radio-button
							[checked]="!passwordField.hasError('noUppercase')"
							[disabled]="true"
							value="noUppercase"
						>
							Incluir una mayúscula (A-Z)
						</mat-radio-button>
					</mat-radio-group>
				</div>
			</div>
			<div class="__field-wrapper">
				<mat-form-field class="__field" appearance="standard">
					<mat-label>Cofirmar Contraseña</mat-label>
					<div class="__input-wrapper">
						<input
							formControlName="confirmPassword"
							matInput
							[type]="showConfirmPassword ? 'text' : 'password'"
							placeholder="Ingrese su contraseña"
						/>
						<div class="__icons" (click)="toggleConfirmPassword($event)">
							<mat-icon
								class="__eye text-muted"
								[ngClass]="{ '--show': showConfirmPassword }"
								>visibility</mat-icon
							>
							<mat-icon
								class="__eye text-muted"
								[ngClass]="{ '--show': !showConfirmPassword }"
							>
								visibility_off
							</mat-icon>
						</div>
					</div>
					<mat-error
						*ngIf="
							confirmPasswordField.touched &&
							confirmPasswordField.hasError('required')
						"
					>
						La confirmación de contraseña es requerida
					</mat-error>
				</mat-form-field>
			</div>

			<div
				class="__field-wrapper __terms-container"
				[ngClass]="{
					'mt3': confirmPasswordField.touched && !confirmPasswordField.valid
				}"
			>
				<mat-checkbox formControlName="acceptedTerms" [disabled]="!openedTerms"
					>He leído y aceptado las
					<a href="#" target="_blank" (click)="openTerms($event)" class="__terms-link"
						>políticas de privacidad</a
					></mat-checkbox
				>
			</div>
			<button
				mat-raised-button
				class="__button"
				color="primary"
				[disabled]="form.invalid || loading"
			>
				{{ loading ? 'Cargando' : 'Restablecer contraseña' }}
				<mat-icon class="mr1" *ngIf="!loading">autorenew</mat-icon>
			</button>
		</form>
	</div>
	<div class="__image-container" *ngIf="token">
		<img
			class="__image"
			src="assets/images/background_login.png"
			alt="Login Background"
		/>
	</div>
</div>
<ng-template #noTokenTemplate>
	<div class="error-container">
		<img class="__logo" src="assets/images/logo.jpg" alt="Logo" />
		<h2 class="h1 title">El enlace de recuperación ha expirado</h2>
		<p class="text-muted-dark">
			El enlace ha expirado debido a que se excedió el tiempo máximo permitido
			para su uso o porque ya fue utilizado previamente. Por favor, genere una
			nueva solicitud para obtener un enlace válido y continuar con el proceso.
		</p>
		<button
			mat-button
			class="__button __go-back"
			color="primary"
			(click)="navigateToLogin()"
		>
			<mat-icon class="mr1">arrow_back</mat-icon>
			Volver al inicio de sesión
		</button>
		<app-request-support-button></app-request-support-button>
	</div>
</ng-template>
